/*
 *
 * ConsentsPopup
 *
 * @version 1.0.0
 * @author Lucio Chiummo
 * @since 03-Oct-2025
 */

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: <PortalMessage id='t.app.consents.popup.title' defaultMessage='Un’esperienza sempre più personalizzata' />,
  t1Title: (
    <PortalMessage id='t.app.consents.popup.t1.title' defaultMessage='Consenso al trattamento dei dati personali' />
  ),
  t1Description: (
    <PortalMessage
      id='t.app.consents.popup.t1.description'
      defaultMessage='Vogliamo darti l’opportunità di godere di tutti i vantaggi del mondo Nexi. Per questo, abbiamo bisogno del tuo consenso per garantirti l’accesso a tutti i nostri servizi.'
    />
  ),
  c1Title: <PortalMessage id='t.app.consents.popup.c1.title' defaultMessage='Per rimanere sempre aggiornato' />,
  c1Description: (
    <PortalMessage
      id='t.app.consents.popup.c1.description'
      defaultMessage='Desidero ricevere comunicazioni commerciali da Nexi relative a promozioni e offerte di Nexi e dei suoi Partner commerciali.'
    />
  ),
  c2Title: <PortalMessage id='t.app.consents.popup.c2.title' defaultMessage='Per migliorare il servizio' />,
  c2Description: (
    <PortalMessage
      id='t.app.consents.popup.c2.description'
      defaultMessage='Autorizzo ad effettuare indagini di mercato o customer satisfaction relative ai servizi e alle attività svolte da Nexi.'
    />
  ),
  c3Title: (
    <PortalMessage
      id='t.app.consents.popup.c3.title'
      defaultMessage='Per attività di promozione commerciale da terzi'
    />
  ),
  c3Description: (
    <PortalMessage
      id='t.app.consents.popup.c3.description'
      defaultMessage='Autorizzo a trasferire i miei dati ad aziende terze, selezionate da Nexi, per finalità commerciali.'
    />
  ),
  confirm: <PortalMessage id='t.app.confirm' defaultMessage='Conferma' />,
  radioYes: <PortalMessage id='t.app.consents.popup.radio.yes' defaultMessage='Si' />,
  radioNo: <PortalMessage id='t.app.consents.popup.radio.no' defaultMessage='No' />,
  requiredError: <PortalMessage id='t.app.error.requiredField' defaultMessage='Il campo è obbligatorio' />
}

export default formattedMessage
